import React from "react";
import S from "./strings";
import { isRtlLanguage } from "./locale";
import useUiLanguage from "./useUiLanguage";

// COACHING PERSONALITY — "Delete coaching personality?".
//
// TWO SENTENCES, TWO ELEMENTS. The prototype writes the body as one string with
// the lock sentence appended: "Your result is removed immediately and
// everywhere. {deleteLockLine}". Both halves are registered separately, and a
// node holding both would match neither key, so the dot between them is markup
// and each sentence keeps its own element.
//
// The lock sentence is the point of the dialog: Konzept 4.5 says deleting does
// NOT reset the six month lock, so the person about to delete is told, before
// they do it, when they may answer again.

const DeleteDialog = ({ lockLine, onCancel, onConfirm, busy = false }) => {
  const language = useUiLanguage();
  const rtl = isRtlLanguage(language);

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-[rgba(17,24,39,0.45)]"
      onClick={onCancel}
      role="presentation"
    >
      <div
        dir={rtl ? "rtl" : undefined}
        role="dialog"
        aria-modal="true"
        aria-label={S.deleteTitle}
        className="bg-white rounded-[14px] p-6 w-full max-w-[420px] shadow-[0_20px_50px_rgba(17,24,39,0.25)]"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="text-[16px] font-bold text-[#111827]">{S.deleteTitle}</div>
        <p className="mt-[10px] text-[14px] leading-[1.55] text-[#374151]">
          {S.deleteBody}
        </p>
        {lockLine && (
          <p className="mt-1 text-[14px] leading-[1.55] text-[#374151]">
            {lockLine}
          </p>
        )}
        <div className="flex flex-wrap justify-end gap-[10px] mt-5">
          <button
            type="button"
            onClick={onCancel}
            className="min-h-[44px] px-[18px] rounded-[10px] border border-[#E5E7EB] bg-white text-[#374151] text-[14px] font-semibold"
          >
            {S.cancel}
          </button>
          <button
            type="button"
            onClick={onConfirm}
            disabled={busy}
            className={`min-h-[44px] px-[18px] rounded-[10px] border-none bg-[#DC2626] text-white text-[14px] font-semibold ${
              busy ? "opacity-60" : "hover:bg-[#B91C1C]"
            }`}
          >
            {S.delete}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteDialog;
